import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_VESSEL_LIST:
      return { ...action.vesselList };
    default:
      return state;
  }
};
